import { Contact, ContactSearchOptions } from '@atlassian/cssxp-types-contact';
import { Results } from '@atlassian/cssxp-typescommon';
import { createAxiosClient, ServiceProxyMap } from '@atlassian/temp-client-utils';

const client = createAxiosClient({ baseURL: '/api/1/contacts' }, ServiceProxyMap.ANS);

export async function searchContacts(searchParams: ContactSearchOptions): Promise<Results<Contact>> {
  const result = await client.get('/', {
    params: searchParams,
  });

  return result.data;
}
